import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = {
  class: "dsp-popover-content"
};
const _hoisted_4 = {
  class: "title-and-value"
};
const _hoisted_5 = {
  class: "details"
};
const _hoisted_6 = {
  class: "detail-title-and-value-container"
};
const _hoisted_7 = {
  class: "detail-title-and-value"
};
const _hoisted_8 = {
  class: "detail-title"
};
const _hoisted_9 = {
  class: "detail-title"
};
const _hoisted_10 = {
  class: "detail-title-and-value"
};
const _hoisted_11 = {
  class: "detail-title"
};
const _hoisted_12 = {
  class: "detail-title"
};
const _hoisted_13 = {
  class: "detail-title-and-value"
};
const _hoisted_14 = {
  class: "detail-title"
};
const _hoisted_15 = {
  class: "detail-title"
};
const _hoisted_16 = {
  class: "detail-title-and-value"
};
const _hoisted_17 = {
  class: "detail-title"
};
const _hoisted_18 = {
  class: "detail-title"
};
const _hoisted_19 = {
  style: {
    "text-align": "center"
  }
};
const _hoisted_20 = {
  style: {
    "text-align": "center"
  }
};
const _hoisted_21 = {
  class: "dsp-popover-content"
};
const _hoisted_22 = {
  class: "title-and-value"
};
const _hoisted_23 = {
  class: "details"
};
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", {
  class: "bar-background",
  style: {
    flex: '1 0 0',
    borderRadius: '4px',
    height: '4px',
    background: '#EAF6F6'
  }
}, null, -1);
const _hoisted_25 = {
  class: "detail-title-and-value-container"
};
const _hoisted_26 = {
  class: "detail-title-and-value"
};
const _hoisted_27 = {
  class: "detail-title"
};
const _hoisted_28 = {
  class: "detail-title"
};
const _hoisted_29 = {
  class: "detail-title-and-value"
};
const _hoisted_30 = {
  class: "detail-title"
};
const _hoisted_31 = {
  class: "detail-title"
};
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", {
  class: "bar-background",
  style: {
    flex: '1 0 0',
    borderRadius: '4px',
    height: '4px',
    background: '#EAF6F6'
  }
}, null, -1);
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", null, "VTR below 70%", -1);
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", null, "Check viewability threshold in line item settings", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_th = _resolveComponent("b-th");
  const _component_hug_value = _resolveComponent("hug-value");
  const _component_b_tr = _resolveComponent("b-tr");
  const _component_wrap_with_popover = _resolveComponent("wrap-with-popover");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_AppIcon = _resolveComponent("AppIcon");
  const _component_date_value = _resolveComponent("date-value");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_bar_with_value = _resolveComponent("bar-with-value");
  const _component_dot_element = _resolveComponent("dot-element");
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_evolution_value = _resolveComponent("evolution-value");
  const _component_slot_with_evolution_value = _resolveComponent("slot-with-evolution-value");
  const _component_overlap_bar_value = _resolveComponent("overlap-bar-value");
  const _component_boxed_value = _resolveComponent("boxed-value");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_b_table_lite = _resolveComponent("b-table-lite");
  const _component_wrap_table_with_show_more = _resolveComponent("wrap-table-with-show-more");
  const _component_table_with_title = _resolveComponent("table-with-title");
  return _openBlock(), _createBlock(_component_table_with_title, {
    title: "Evolution",
    class: "consideration-period-table",
    noDownload: "",
    fields: $data.fields,
    loading: $props.loading
  }, {
    "period-selector": _withCtx(() => [_renderSlot(_ctx.$slots, "period-selector")]),
    default: _withCtx(() => [_createVNode(_component_wrap_table_with_show_more, {
      modelValue: $options.period_pager,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.period_pager = $event),
      period: _ctx.period
    }, {
      default: _withCtx(() => [_createVNode(_component_b_table_lite, {
        class: "lite-table lite-table-hoverable period-table consideration-table",
        fields: $data.fields,
        bordered: "",
        responsive: "",
        fixed: "",
        items: $options.items,
        "sticky-header": true,
        tbodyTrClass: item => _ctx.handleRowClass(item, $options.items),
        "no-border-collapse": "",
        onRowClicked: $options.handleRowClick
      }, {
        "thead-top": _withCtx(() => [_createVNode(_component_b_tr, {
          class: "headers"
        }, {
          default: _withCtx(() => [_createVNode(_component_b_th, {
            colspan: "1",
            style: {
              borderRight: 'none'
            }
          }), _createVNode(_component_b_th, {
            colspan: "1",
            "sticky-column": ""
          }), _createVNode(_component_b_th, {
            colspan: "1",
            class: "objective left-embrace right-embrace",
            style: {
              color: '#BE510E',
              background: '#FFF1E9'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_hug_value, null, {
              default: _withCtx(() => [_createTextVNode("Objective")]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_b_th, {
            colspan: "2",
            class: "efficiency left-embrace right-embrace",
            style: {
              color: '#5B4806',
              background: '#FFFAED'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_hug_value, null, {
              default: _withCtx(() => [_createTextVNode("Efficiency")]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_b_th, {
            colspan: "3",
            class: "business_results left-embrace right-embrace",
            style: {
              color: '#134890',
              background: '#F4F8FF'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_hug_value, null, {
              default: _withCtx(() => [_createTextVNode("Business Results")]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_b_th, {
            colspan: "1",
            class: "brand_interest left-embrace right-embrace",
            style: {
              color: '#5A52AE',
              background: '#F8F9FF'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_hug_value, null, {
              default: _withCtx(() => [_createTextVNode("Brand Interest")]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_b_th, {
            colspan: "3",
            class: "delivery_quality left-embrace right-embrace",
            style: {
              color: '#348371',
              background: '#ECF9F6'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_hug_value, null, {
              default: _withCtx(() => [_createTextVNode("Delivery Quality")]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_b_th, {
            colspan: "3",
            class: "control left-embrace right-embrace",
            style: {
              color: '#626262',
              background: '#EFEFEF'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_hug_value, null, {
              default: _withCtx(() => [_createTextVNode("Control")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        "head()": _withCtx(col => [_createVNode(_component_flex_row, {
          id: `default-period-table-${col?.column}`,
          styles: {
            justifyContent: col.field.justify,
            ...col.field.thStyle
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
            target: `default-period-table-${col?.column}`
          }, {
            title: _withCtx(() => [_createElementVNode("div", {
              innerHTML: $options.getDescriptionBasedOnKpiKey(col?.column).title
            }, null, 8, _hoisted_1)]),
            content: _withCtx(() => [_createTextVNode(_toDisplayString($options.getDescriptionBasedOnKpiKey(col?.column).detail), 1)]),
            default: _withCtx(() => [_createElementVNode("div", {
              innerHTML: col?.column === 'period_agg' ? $options.getPeriodColumnTitle : col?.label,
              class: "title"
            }, null, 8, _hoisted_2)]),
            _: 2
          }, 1032, ["target"])]),
          _: 2
        }, 1032, ["id", "styles"])]),
        "cell(selector)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_AppIcon, {
            icon: `zoom-${row.item.selected ? 'out' : 'in'}`,
            color: row.item.selected ? null : '#ADADAD',
            size: 16
          }, null, 8, ["icon", "color"])]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(period_agg)": _withCtx(row => [_createVNode(_component_date_value, {
          value: row.item?.period_agg,
          format: $options.getDateValueFormat,
          styles: {
            justifyContent: 'flex-start',
            ..._ctx.activateDateValueStyles(row),
            zIndex: '20'
          },
          loading: $props.loading
        }, null, 8, ["value", "format", "styles", "loading"])]),
        "cell(dsp_consideration_signals)": _withCtx(row => [_createVNode(_component_wrap_with_popover, {
          delay: {
            show: 0,
            hide: 100
          },
          target: `dsp_new_customers_${row.item?.period_agg}`,
          width: 230,
          padding: "8px",
          class: "raos_vs_target_popover",
          customClass: "dsp-popover"
        }, {
          content: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createTextVNode(" New Customers "), _createVNode(_component_currency_value, {
            value: row.item?.consideration_signals,
            loading: $props.loading,
            showSymbol: false,
            align: "right",
            allowPrecisionModification: false,
            charCount: $options.maxCharCount?.currency?.consideration_signals,
            precision: row.item?.consideration_signals > 1000000 ? 1 : 0
          }, null, 8, ["value", "loading", "charCount", "precision"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_bar_with_value, {
            value: row.item?.consideration_atc_clicks,
            min: Math.min($options.minMax?.consideration_signals?.min, $options.minMax?.consideration_atc_clicks?.min, $options.minMax?.consideration_atc_views?.min, $options.minMax?.consideration_dpv_clicks?.min, $options.minMax?.consideration_dpv_views?.min),
            color: "#BE510E",
            max: $options.minMax?.consideration_signals?.max,
            loading: $props.loading,
            height: 15,
            tight: "",
            style: {
              "width": "100%"
            }
          }, {
            "bar-append": _withCtx(() => [_createElementVNode("div", {
              class: "bar-background",
              style: _normalizeStyle({
                width: `${row.item?.consideration_dpv_clicks / $options.minMax?.consideration_signals?.max * 100 ?? 0}%`,
                borderRadius: '0',
                height: '15px',
                background: '#FCAF83'
              })
            }, null, 4), _createElementVNode("div", {
              class: "bar-background",
              style: _normalizeStyle({
                width: `${row.item?.consideration_atc_views / $options.minMax?.consideration_signals?.max * 100 ?? 0}%`,
                borderRadius: '0',
                height: '15px',
                background: '#FFCCAD'
              })
            }, null, 4), _createElementVNode("div", {
              class: "bar-background",
              style: _normalizeStyle({
                width: `${row.item?.consideration_dpv_views / $options.minMax?.consideration_signals?.max * 100 ?? 0}%`,
                borderRadius: '0 4px 4px 0',
                height: '15px',
                background: '#FFE9DB'
              })
            }, null, 4)]),
            _: 2
          }, 1032, ["value", "min", "max", "loading"]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_dot_element, {
            color: "#BE510E",
            size: 8
          }), _createTextVNode(" ATC Clicks ")]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_currency_value, {
            value: row.item?.consideration_atc_clicks,
            loading: $props.loading,
            showSymbol: false,
            align: "right",
            allowPrecisionModification: false,
            charCount: $options.maxCharCount?.currency?.consideration_atc_clicks,
            precision: row.item?.consideration_atc_clicks > 1000000 ? 1 : 0
          }, null, 8, ["value", "loading", "charCount", "precision"])])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_dot_element, {
            color: "#FCAF83",
            size: 8
          }), _createTextVNode(" DPV Clicks ")]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_currency_value, {
            value: row.item?.consideration_dpv_clicks,
            loading: $props.loading,
            showSymbol: false,
            align: "right",
            allowPrecisionModification: false,
            charCount: $options.maxCharCount?.currency?.consideration_dpv_clicks,
            precision: row.item?.consideration_dpv_clicks > 1000000 ? 1 : 0
          }, null, 8, ["value", "loading", "charCount", "precision"])])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_dot_element, {
            color: "#FFCCAD",
            size: 8
          }), _createTextVNode(" ATC Views ")]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_currency_value, {
            value: row.item?.consideration_atc_views,
            loading: $props.loading,
            showSymbol: false,
            align: "right",
            allowPrecisionModification: false,
            charCount: $options.maxCharCount?.currency?.consideration_atc_views,
            precision: row.item?.consideration_atc_views > 1000000 ? 1 : 0
          }, null, 8, ["value", "loading", "charCount", "precision"])])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_dot_element, {
            color: "#FFE9DB",
            size: 8
          }), _createTextVNode(" DPV Views ")]), _createElementVNode("div", _hoisted_18, [_createVNode(_component_currency_value, {
            value: row.item?.consideration_dpv_views,
            loading: $props.loading,
            showSymbol: false,
            align: "right",
            allowPrecisionModification: false,
            charCount: $options.maxCharCount?.currency?.consideration_dpv_views,
            precision: row.item?.consideration_dpv_views > 1000000 ? 1 : 0
          }, null, 8, ["value", "loading", "charCount", "precision"])])])])])])]),
          default: _withCtx(() => [_createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "position": "relative"
            },
            id: `dsp_new_customers_${row.item?.period_agg}`
          }, {
            default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
              gap: 8
            }, {
              evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
                value: row.item?.[`consideration_signals_evol${$data.evolCategory[_ctx.periodCategory]}`]
              }, {
                default: _withCtx(({
                  color
                }) => [_createVNode(_component_percentage_value, {
                  value: row.item?.[`consideration_signals_evol${$data.evolCategory[_ctx.periodCategory]}`],
                  charCount: $options.maxCharCount?.percentage?.[`consideration_signals_evol${$data.evolCategory[_ctx.periodCategory]}`],
                  align: "right",
                  tight: "",
                  color: color
                }, null, 8, ["value", "charCount", "color"])]),
                _: 2
              }, 1032, ["value"])]),
              default: _withCtx(() => [_createVNode(_component_bar_with_value, {
                value: row.item?.consideration_atc_clicks,
                min: Math.min($options.minMax?.consideration_signals?.min, $options.minMax?.consideration_atc_clicks?.min),
                color: "#F89053",
                max: $options.minMax?.consideration_signals?.max,
                loading: $props.loading,
                height: 15,
                tight: ""
              }, {
                "bar-append": _withCtx(() => [_createElementVNode("div", {
                  class: "bar-background",
                  style: _normalizeStyle({
                    width: `${row.item?.consideration_dpv_clicks / $options.minMax?.consideration_signals?.max * 100 ?? 0}%`,
                    borderRadius: '0',
                    height: '15px',
                    background: '#FCAF83'
                  })
                }, null, 4), _createElementVNode("div", {
                  class: "bar-background",
                  style: _normalizeStyle({
                    width: `${row.item?.consideration_atc_views / $options.minMax?.consideration_signals?.max * 100 ?? 0}%`,
                    borderRadius: '0',
                    height: '15px',
                    background: '#FFCCAD'
                  })
                }, null, 4), _createElementVNode("div", {
                  class: "bar-background",
                  style: _normalizeStyle({
                    width: `${row.item?.consideration_dpv_views / $options.minMax?.consideration_signals?.max * 100 ?? 0}%`,
                    borderRadius: '0 4px 4px 0',
                    height: '15px',
                    background: '#FFE9DB'
                  })
                }, null, 4)]),
                default: _withCtx(() => [_createVNode(_component_currency_value, {
                  value: row.item?.consideration_signals,
                  loading: $props.loading,
                  showSymbol: false,
                  align: "right",
                  allowPrecisionModification: false,
                  charCount: $options.maxCharCount?.currency?.consideration_signals,
                  precision: row.item?.consideration_signals > 1000000 ? 1 : 0
                }, null, 8, ["value", "loading", "charCount", "precision"])]),
                _: 2
              }, 1032, ["value", "min", "max", "loading"])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1032, ["loading", "id"])]),
          _: 2
        }, 1032, ["target"])]),
        "cell(dsp_dpvr_vs_target)": _withCtx(row => [_createVNode(_component_wrap_with_popover, {
          target: `roas_vs_target_${row.item?.period_agg}`,
          width: 124,
          padding: "8px",
          class: "raos_vs_target_popover"
        }, {
          title: _withCtx(() => [_createElementVNode("div", _hoisted_19, "Target DPVR: " + _toDisplayString(Math.round(row.item?.consideration_target * 10000) / 100) + "%", 1)]),
          content: _withCtx(() => [_createElementVNode("div", _hoisted_20, _toDisplayString(row.item?.consideration_target > row.item?.consideration_dpvr ? 'Below Target' : 'Above Target'), 1)]),
          default: _withCtx(() => [_createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "position": "relative"
            },
            id: `roas_vs_target_${row.item?.period_agg}`
          }, {
            default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
              value: row.item?.consideration_dpvr,
              background: "",
              borderColor: `${row.item?.consideration_dpvr >= row.item?.consideration_target ? '#DEFBE6' : '#FFF0F1'}`,
              min: 0,
              max: Math.max($options.minMax?.consideration_dpvr?.max, $options.minMax?.consideration_target?.max),
              loading: $props.loading,
              align: "left",
              barStyles: {
                borderRight: `${row.item?.consideration_dpvr >= row.item?.consideration_target ? '1.2px solid #22863D ' : '1.2px solid #E7747A'}`,
                borderRadius: '4px',
                height: '20px',
                background: `${row.item?.consideration_dpvr >= row.item?.consideration_target ? '#DEFBE6' : '#FFF0F1'}`
              },
              style: {
                "width": "100%",
                "position": "absolute",
                "z-index": "1"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_percentage_value, {
                value: row.item?.consideration_dpvr,
                charCount: $options.maxCharCount?.percentage?.consideration_dpvr,
                precision: 2,
                tight: ""
              }, null, 8, ["value", "charCount"])]),
              _: 2
            }, 1032, ["value", "borderColor", "max", "loading", "barStyles"]), _createVNode(_component_overlap_bar_value, {
              value: row.item?.consideration_target,
              background: "",
              borderColor: "#E3E3E3",
              min: 0,
              max: Math.max($options.minMax?.consideration_dpvr?.max, $options.minMax?.consideration_target?.max),
              loading: $props.loading,
              align: "left",
              barStyles: {
                borderRight: 'none',
                borderRadius: '4px',
                height: '20px',
                background: '#E3E3E3'
              },
              style: {
                "width": "100%",
                "position": "absolute"
              }
            }, null, 8, ["value", "max", "loading"])]),
            _: 2
          }, 1032, ["loading", "id"])]),
          _: 2
        }, 1032, ["target"])]),
        "cell(dsp_cpa_consideration)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_currency_value, {
            valueAlign: "right",
            value: row.item?.consideration_cpa_signal,
            precision: 2,
            charCount: $options.maxCharCount?.currency?.consideration_cpa_signal + 2
          }, null, 8, ["value", "charCount"])]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(dsp_spend)": _withCtx(row => [_createVNode(_component_overlap_bar_value, {
          value: row.item?.consideration_spend,
          background: "",
          borderColor: "#E0ECFF",
          min: Math.min($options.minMax?.consideration_spend?.min, $options.minMax?.consideration_dpv?.min),
          max: Math.max($options.minMax?.consideration_spend?.max, $options.minMax?.consideration_dpv?.max),
          loading: $props.loading,
          align: "right",
          styles: {
            padding: '0 1px 0 8px'
          },
          barStyles: {
            borderLeft: 'none',
            borderRadius: '4px',
            height: '22px',
            background: '#E0ECFF'
          },
          class: "purchase-share-bar"
        }, {
          default: _withCtx(() => [_createVNode(_component_currency_value, {
            value: row.item?.consideration_spend,
            loading: $props.loading,
            allowPrecisionModification: false,
            charCount: $options.maxCharCount?.currency?.consideration_spend,
            precision: row.item?.consideration_spend > 1000000 ? 1 : 0
          }, null, 8, ["value", "loading", "charCount", "precision"])]),
          _: 2
        }, 1032, ["value", "min", "max", "loading"])]),
        "cell(dsp_dpv)": _withCtx(row => [_createVNode(_component_overlap_bar_value, {
          value: row.item?.consideration_dpv,
          background: "",
          borderColor: "#ADCDFF",
          min: Math.min($options.minMax?.consideration_spend?.min, $options.minMax?.consideration_dpv?.min),
          max: Math.max($options.minMax?.consideration_spend?.max, $options.minMax?.consideration_dpv?.max),
          loading: $props.loading,
          align: "left",
          styles: {
            padding: '0 8px 0 1px'
          },
          barStyles: {
            borderLeft: 'none',
            borderRadius: '4px',
            height: '22px',
            background: '#ADCDFF'
          },
          class: "purchase-share-bar"
        }, {
          default: _withCtx(() => [_createVNode(_component_currency_value, {
            value: row.item?.consideration_dpv,
            loading: $props.loading,
            showSymbol: false,
            allowPrecisionModification: false,
            charCount: $options.maxCharCount?.currency?.consideration_dpv,
            precision: row.item?.consideration_dpv > 1000000 ? 1 : 0,
            valueAlign: "left"
          }, null, 8, ["value", "loading", "charCount", "precision"])]),
          _: 2
        }, 1032, ["value", "min", "max", "loading"])]),
        "cell(dsp_atc)": _withCtx(row => [_createVNode(_component_overlap_bar_value, {
          value: row.item?.consideration_atc,
          background: "",
          borderColor: "#E3EDF7",
          min: $options.minMax?.consideration_atc?.min,
          max: $options.minMax?.consideration_atc?.max,
          loading: $props.loading,
          align: "left",
          barStyles: {
            borderLeft: 'none',
            borderRadius: '4px',
            height: '22px',
            background: '#E3EDF7'
          },
          class: "purchase-share-bar"
        }, {
          default: _withCtx(() => [_createVNode(_component_currency_value, {
            valueAlign: "left",
            value: row.item?.consideration_atc,
            loading: $props.loading,
            showSymbol: false,
            align: "left",
            allowPrecisionModification: false,
            charCount: $options.maxCharCount?.currency?.consideration_atc,
            precision: row.item?.consideration_atc > 1000000 ? 1 : 0
          }, null, 8, ["value", "loading", "charCount", "precision"])]),
          _: 2
        }, 1032, ["value", "min", "max", "loading"])]),
        "cell(dsp_brand_searches)": _withCtx(row => [_createVNode(_component_overlap_bar_value, {
          value: row.item?.consideration_brand_searches,
          background: "",
          borderColor: "#F8F9FF",
          min: $options.minMax?.consideration_brand_searches?.min,
          max: $options.minMax?.consideration_brand_searches?.max,
          loading: $props.loading,
          align: "left",
          barStyles: {
            borderLeft: 'none',
            borderRadius: '4px',
            height: '22px',
            background: '#F8F9FF'
          },
          class: "purchase-share-bar"
        }, {
          default: _withCtx(() => [_createVNode(_component_currency_value, {
            valueAlign: "left",
            value: row.item?.consideration_brand_searches,
            loading: $props.loading,
            showSymbol: false,
            align: "left",
            allowPrecisionModification: false,
            charCount: $options.maxCharCount?.currency?.consideration_brand_searches,
            precision: row.item?.consideration_brand_searches > 1000000 ? 1 : 0
          }, null, 8, ["value", "loading", "charCount", "precision"])]),
          _: 2
        }, 1032, ["value", "min", "max", "loading"])]),
        "cell(dsp_ecpm)": _withCtx(row => [_createVNode(_component_boxed_value, {
          bgColor: $options.getColorForDecile(row.item?.consideration_ecpm, $options.minMax?.consideration_ecpm?.min, $options.minMax?.consideration_ecpm?.max, $data.ECPM_DECILE_COLORS, 5, 4),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_currency_value, {
            value: row.item?.consideration_ecpm,
            precision: 2
          }, null, 8, ["value"])]),
          _: 2
        }, 1032, ["bgColor", "loading"])]),
        "cell(dsp_impressions)": _withCtx(row => [_createVNode(_component_wrap_with_popover, {
          delay: {
            show: 0,
            hide: 100
          },
          target: `dsp_impressions_${row.item?.period_agg}`,
          width: 230,
          padding: "8px",
          class: "raos_vs_target_popover",
          customClass: "dsp-popover"
        }, {
          content: _withCtx(() => [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createTextVNode(" Impressions "), _createVNode(_component_currency_value, {
            value: row.item?.consideration_viewable_impressions + row.item?.consideration_non_viewable_impressions,
            loading: $props.loading,
            showSymbol: false,
            align: "right",
            allowPrecisionModification: false,
            charCount: $options.maxCharCount?.currency?.consideration_viewable_impressions,
            precision: row.item?.consideration_viewable_impressions > 1000000 ? 1 : 0
          }, null, 8, ["value", "loading", "charCount", "precision"])]), _createElementVNode("div", _hoisted_23, [_createVNode(_component_bar_with_value, {
            value: row.item?.consideration_viewable_impressions / (row.item?.consideration_viewable_impressions + row.item?.consideration_non_viewable_impressions),
            min: 0,
            color: "#1EBDBD",
            max: 1,
            loading: $props.loading,
            style: {
              "width": "100%"
            }
          }, {
            "bar-append": _withCtx(() => [_hoisted_24]),
            _: 2
          }, 1032, ["value", "loading"]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createVNode(_component_dot_element, {
            color: "#1EBDBD",
            size: 8
          }), _createTextVNode(" Viewable impre. ")]), _createElementVNode("div", _hoisted_28, [_createVNode(_component_currency_value, {
            value: row.item?.consideration_viewable_impressions,
            loading: $props.loading,
            showSymbol: false,
            align: "right",
            allowPrecisionModification: false,
            charCount: $options.maxCharCount?.currency?.consideration_viewable_impressions,
            precision: row.item?.consideration_viewable_impressions > 1000000 ? 1 : 0
          }, null, 8, ["value", "loading", "charCount", "precision"]), _createVNode(_component_percentage_value, {
            value: row.item?.consideration_viewable_impressions / (row.item?.consideration_non_viewable_impressions + row.item?.consideration_viewable_impressions),
            charCount: 3
          }, null, 8, ["value"])])]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createVNode(_component_dot_element, {
            color: "#E9F6F6",
            size: 8
          }), _createTextVNode(" Non-Viewable impre. ")]), _createElementVNode("div", _hoisted_31, [_createVNode(_component_currency_value, {
            value: row.item?.consideration_non_viewable_impressions,
            loading: $props.loading,
            showSymbol: false,
            align: "right",
            allowPrecisionModification: false,
            charCount: $options.maxCharCount?.currency?.consideration_non_viewable_impressions,
            precision: row.item?.consideration_non_viewable_impressions > 1000000 ? 1 : 0
          }, null, 8, ["value", "loading", "charCount", "precision"]), _createVNode(_component_percentage_value, {
            value: row.item?.consideration_non_viewable_impressions / (row.item?.consideration_non_viewable_impressions + row.item?.consideration_viewable_impressions),
            charCount: 3
          }, null, 8, ["value"])])])])])])]),
          default: _withCtx(() => [_createVNode(_component_bar_with_value, {
            value: row.item?.consideration_viewable_impressions / (row.item?.consideration_viewable_impressions + row.item?.consideration_non_viewable_impressions),
            min: 0,
            color: "#1EBDBD",
            max: 1,
            loading: $props.loading,
            style: {
              "position": "relative"
            },
            id: `dsp_impressions_${row.item?.period_agg}`
          }, {
            "bar-append": _withCtx(() => [_hoisted_32]),
            default: _withCtx(() => [_createVNode(_component_currency_value, {
              value: row.item?.consideration_viewable_impressions + row.item?.consideration_non_viewable_impressions,
              loading: $props.loading,
              showSymbol: false,
              align: "right",
              allowPrecisionModification: false,
              charCount: $options.maxCharCount?.currency?.consideration_viewable_impressions,
              precision: row.item?.consideration_viewable_impressions > 1000000 ? 1 : 0
            }, null, 8, ["value", "loading", "charCount", "precision"])]),
            _: 2
          }, 1032, ["value", "loading", "id"])]),
          _: 2
        }, 1032, ["target"])]),
        "cell(dsp_vtr)": _withCtx(row => [_createVNode(_component_boxed_value, {
          bgColor: $options.getColorsBasedOnRange(row.item?.consideration_vtr, [[[Number.NEGATIVE_INFINITY, 0.69], '#FFF0F1'], [[0.7, Number.POSITIVE_INFINITY], '#FFF']]),
          loading: $props.loading,
          styles: {
            justifyContent: `${Math.round(row.item?.consideration_vtr * 100) < 70 ? 'space-between' : 'flex-end'}`,
            gap: '2px'
          }
        }, {
          default: _withCtx(() => [Math.round(row.item?.consideration_vtr * 100) < 70 ? (_openBlock(), _createBlock(_component_wrap_with_popover, {
            key: 0
          }, {
            title: _withCtx(() => [_hoisted_33]),
            content: _withCtx(() => [_hoisted_34]),
            default: _withCtx(() => [_createVNode(_component_app_icon, {
              icon: "info-circle",
              color: "#931A1F",
              size: 10,
              class: "dsp_vtr_info"
            })]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_percentage_value, {
            value: row.item?.consideration_vtr
          }, null, 8, ["value"])]),
          _: 2
        }, 1032, ["bgColor", "loading", "styles"])]),
        "cell(dsp_delivery_rate)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: row.item?.consideration_delivery_rate,
            color: $options.getColorsBasedOnRange(row.item?.consideration_delivery_rate, $data.DSP_DELIVERY_RATE_COLORS),
            styles: {
              background: $options.getColorsBasedOnRange(row.item?.consideration_delivery_rate, $data.DSP_DELIVERY_RATE_BG_COLORS),
              padding: '1px 8px',
              borderRadius: '6px'
            }
          }, null, 8, ["value", "color", "styles"])]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(dsp_percent_ntb_cust)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: row.item?.consideration_share_of_ntb,
            color: $options.getColorsBasedOnRange(row.item?.consideration_share_of_ntb, $data.DSP_NTB_CUSTOMERS_RATE_COLORS),
            styles: {
              background: $options.getColorsBasedOnRange(row.item?.consideration_share_of_ntb, $data.DSP_NTB_CUSTOMERS_RATE_BG_COLORS),
              padding: '1px 8px',
              borderRadius: '6px'
            }
          }, null, 8, ["value", "color", "styles"])]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(dsp_percent_dpv_click)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: row.item?.consideration_dpv_click_ratio,
            precision: 1
          }, null, 8, ["value"])]),
          _: 2
        }, 1032, ["loading"])]),
        _: 1
      }, 8, ["fields", "items", "tbodyTrClass", "onRowClicked"])]),
      _: 1
    }, 8, ["modelValue", "period"])]),
    _: 3
  }, 8, ["fields", "loading"]);
}